import React from 'react';
export default function useForceUpdate() {
  const setUpdate = React.useState(0)[1];
  const forceUpdate = React.useCallback(() => setUpdate(u => u + 1), []);
  return forceUpdate;
}